export const pageSelector = ({ activeIds, entities }) => ({
  activeAdvanceId: activeIds.advanceId,
  activeForgivenessId: activeIds.forgivenessId,
  advancesById: entities.advances.byId,
  loanForgiveness: entities.loanForgiveness,
});
